import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useParams } from 'react-router-dom';
import { Ban, CheckCircle2 } from 'lucide-react';
export function UnsubscribePage() {
  const {
    token
  } = useParams();
  const [isUnsubscribed, setIsUnsubscribed] = useState(false);
  const handleUnsubscribe = () => {
    setIsUnsubscribed(true);
  };
  return <div className="min-h-screen bg-background text-textMain flex items-center justify-center p-6" data-id="element-7117">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} className="max-w-md w-full bg-surface border border-border rounded-2xl p-8 text-center" data-id="element-7118">
        {!isUnsubscribed ? <>
            <div className="w-16 h-16 rounded-full bg-surfaceHover flex items-center justify-center mx-auto mb-6" data-id="element-7119">
              <Ban className="w-8 h-8 text-textMuted" data-id="element-7120" />
            </div>
            <h1 className="text-2xl font-bold mb-2" data-id="element-7121">Unsubscribe</h1>
            <p className="text-textMuted mb-8" data-id="element-7122">
              Are you sure you want to unsubscribe? You will no longer receive
              booking inquiries or updates from <strong data-id="element-7123">The Wildwoods</strong>.
            </p>
            <div className="space-y-3" data-id="element-7124">
              <button onClick={handleUnsubscribe} className="w-full py-3 bg-red-500/10 text-red-500 rounded-xl font-medium hover:bg-red-500/20 transition-colors" data-id="element-7125">
                Yes, unsubscribe me
              </button>
              <button className="w-full py-3 bg-surface border border-border rounded-xl font-medium hover:bg-surfaceHover transition-colors" data-id="element-7126">
                Cancel
              </button>
            </div>
          </> : <>
            <div className="w-16 h-16 rounded-full bg-green-500/20 text-green-500 flex items-center justify-center mx-auto mb-6" data-id="element-7127">
              <CheckCircle2 className="w-8 h-8" data-id="element-7128" />
            </div>
            <h1 className="text-2xl font-bold mb-2" data-id="element-7129">Unsubscribed</h1>
            <p className="text-textMuted" data-id="element-7130">
              You have been successfully removed from this mailing list. You can
              close this window.
            </p>
          </>}
      </motion.div>
    </div>;
}